module.exports = __webpack_public_path__ + "img/LoggableMacBook2.69ec8cbc.png";